import applicationImg from '@/assets/funnel28/application.webp';
import interviewImg from '@/assets/funnel28/interview.webp';
import morganImg from '@/assets/funnel28/morgan.webp';
import nvidiaImg from '@/assets/funnel28/nvidia.webp';

const features = [
  {
    title: 'Get matched with the best-fit jobs you’re most likely to land',
    description:
      'In seconds, we scan thousands of job boards and career pages to find open opportunities that match your salary goals, experience, and other preferences.',
    comparisons: [
      { text: 'Find 20x more relevant jobs', type: 'green' },
      { text: 'Cut search time by 90%', type: 'green' },
    ],
    image: nvidiaImg,
  },
  {
    title: 'We build your resume and tailor it perfectly for every application',
    description:
      'Our system builds you a professional-grade resume and personalizes it for any job \u2014 perfectly matching the role\u2019s requirements and maximizing your chances of landing an interview.',
    comparisons: [
      { text: 'Get 10x more interviews', type: 'blue' },
      { text: 'Land interviews 5x faster', type: 'blue' },
    ],
    image: morganImg,
  },
  {
    title: 'Auto-apply to countless jobs instantly',
    description:
      'Apply to tons of companies faster and save hours by automatically filling and sending job applications \u2014 all tracked and managed in a fully automated dashboard.',
    comparisons: [
      { text: 'Send 50x more applications', type: 'purple' },
      { text: 'Cut application time by 95%', type: 'purple' },
    ],
    image: applicationImg,
  },
  {
    title: 'Ace any interview and negotiation',
    description:
      'Practice with our interview or negotiation simulator \u2014 get real-time personalized feedback, answers, and guidance. Or download an Answer Pack with tailored responses for your exact scenario.',
    comparisons: [
      { text: 'Get 5x more job offers', type: 'yellow' },
      { text: 'Get the highest offer possible', type: 'yellow' },
    ],
    image: interviewImg,
  },
];

const FeatureCard = ({ title, description, comparisons, image }) => {
  return (
    <div className="flex flex-col md:gap-6 gap-4 border border-[#0000000F] rounded-2xl p-4 lg:p-8">
      {image && <img src={image} alt={title} className="object-contain mb-2" />}
      <h3 className="text-xl md:text-2xl font-bold font-['Inter']">{title}</h3>
      <p className="text-[#535353]">{description}</p>
      <div>
        <p className="text-sm mb-3 font-semibold">Compared to manual process:</p>
        <div className="flex flex-wrap gap-3">
          {comparisons.map((comparison, index) => (
            <div key={index} className="py-2 px-4 rounded-[8px] flex items-center gap-2 bg-[#FFF7F5] w-full">
              <div className="w-2 h-2 rounded-full bg-[#E43C5F]" />
              <>{comparison.text}</>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const FeaturesSection = ({ buttons }) => (
  <>
    <div className="bg-white py-8 pb-8 lg:py-24" id="features">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-20">
        <div className="text-left sm:text-center mb-4">
          <div className="inline-flex items-center gap-2 mb-4  border border-[#0000000F] px-4 py-2 rounded-lg">
            <div className="w-2 h-2 rounded-full bg-[#08711D]"></div>
            <span className="text-sm font-medium">Features</span>
          </div>
          <h2 className="text-[32px] md:text-[48px] lg:text-5xl font-semibold font-['Inter'] md:max-w-[80%] md:m-auto">
            How it works
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6 lg:gap-10 mb-12">
          {features.map((feature, index) => (
            <FeatureCard key={index} {...feature} />
          ))}
        </div>
        <div className="flex flex-col items-center mt-8 gap-6">{buttons}</div>
      </div>
    </div>
  </>
);
